/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadDetailDto } from '../../models/lexplus-upload-detail-dto';

export interface UploadsControllerFindOneByIdV1$Params {
  id: string;
}

export function uploadsControllerFindOneByIdV1(http: HttpClient, rootUrl: string, params: UploadsControllerFindOneByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusUploadDetailDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerFindOneByIdV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusUploadDetailDto>;
    })
  );
}

uploadsControllerFindOneByIdV1.PATH = '/v1/uploads/{id}';
